import { render } from "./pageController.vue?vue&type=template&id=1799d3ae&scoped=true"
import script from "./pageController.vue?vue&type=script&lang=js"
export * from "./pageController.vue?vue&type=script&lang=js"

import "./pageController.vue?vue&type=style&index=0&id=1799d3ae&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1799d3ae"]])

export default __exports__